import NoData from '../Common/NoData'
import { Connect, mapDispatchToProps, mapStateToProps } from '../../Redux'
import { Box, Button, CircularProgress, IconButton, InputAdornment, TablePagination, TextField, Tooltip, Typography } from '@mui/material'
import { FC, useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { PropertyProps } from '../../types/properties'
import ProperyInfo from './properyInfo'
import { Apis } from '../../helpers'
import _ from 'lodash'
import { Add, CloseOutlined, FilterListOutlined, Refresh, SearchOutlined } from '@mui/icons-material'
import FilterComponent from '../Common/filter'
import { FilterParamProps } from '../Common/Toolbar'


interface StateProps {
    loading: boolean
    refreshing: boolean
    searchVal: string
    searching: boolean
    pageSize: number
    page: number
    count: number
    properties: PropertyProps[]
    distinctCities: string[]
    distinctPlaces: string[]
    filter: any
}

export
    const Properties: FC = ({

    }) => {
        const [state, setState] = useState<StateProps>({
            loading: true,
            refreshing: false,
            searchVal: '',
            searching: false,
            page: 0,
            pageSize: 5,
            count: 0,
            distinctCities: [],
            distinctPlaces: [],
            properties: [],
            filter: null
        })
        const { loading, searching, distinctCities, distinctPlaces, refreshing, searchVal, page, pageSize, count, properties, filter } = state
        const navigate = useNavigate()
        const filterOptions = [
            { label: 'City', field: 'city', options: distinctCities, type: 'multiSelect', selected: filter?.city||[] },
            { label: 'Place', field: 'placeName', options: distinctPlaces, type: 'multiSelect', selected: filter?.placeName||[] }
        ]
        const searchProperty = (searchVal: string) => getProperties({
            searchVal,
            processVariable: 'searching',
            newPage: 0
        })
        const getProperties = ({
            searchVal,
            newPage,
            newPageSize,
            processVariable,
            filter
        }: any) => {
            if (processVariable)
                setState({ ...state, [processVariable]: true })
            const NewPage = newPage > -1 ? newPage : state.page
            const NewPageSize = newPageSize || state.pageSize
            const afterLoad = {
                loading: false,
                searching: false,
                refreshing: false
            }
            Apis({
                module: 'Properties',
                action: 'getPropertiesInfo',
                searchVal,
                page: NewPage,
                pageSize: NewPageSize,
                filter: filter || state.filter
            }).then((resp: any) => {
                const { properties, count, distinctPlaces, distinctCities } = resp
                setState({
                    ...state,
                    count: count || state.count,
                    distinctPlaces: distinctPlaces || state.distinctPlaces,
                    distinctCities: distinctCities || state.distinctCities,
                    searchVal,
                    properties,
                    page: NewPage,
                    pageSize: NewPageSize,
                    ...afterLoad,
                    filter
                })
            }).catch(() => {
                setState({
                    ...state,
                    searchVal,
                    page: NewPage,
                    pageSize: NewPageSize,
                    ...afterLoad,
                    filter
                })
            })
        },
            startSearch = useCallback(_.debounce(searchProperty, 1000), [])
        const onFilter = (filter: any) => {
            getProperties({
                newPage: page,
                processVariable: 'loading',
                newPageSize: pageSize,
                filter
            })

        }
  
        useEffect(() => {
            getProperties({
                newPage: page,
                processVariable: 'loading',
                newPageSize: pageSize
            })
            return () => {

            }
        }, [])
        const PRIMARY = '#8c7c0c'

        return (
            <Box sx={{ pb: 4, pr: { xs: 2, md: 4 } }}>

                {/* ── Single-row toolbar ── */}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    mb: 3,
                    pb: 3,
                    borderBottom: '1px solid #f0f0f0',
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                }}>
                    {/* Title block */}
                    <Box sx={{ flexShrink: 0, mr: 0.5 }}>
                        <Typography sx={{ fontSize: 20, fontWeight: 800, color: '#111827', lineHeight: 1.1 }}>
                            Properties
                        </Typography>
                        <Typography sx={{ fontSize: 12, color: '#9ca3af', mt: 0.2, whiteSpace: 'nowrap' }}>
                            {count > 0 ? `${count} ${count === 1 ? 'property' : 'properties'}` : 'Portfolio'}
                        </Typography>
                    </Box>

                    {/* Vertical divider */}
                    <Box sx={{ width: '1px', height: 32, bgcolor: '#e5e7eb', flexShrink: 0, display: { xs: 'none', sm: 'block' } }} />

                    {/* Search — grows to fill space */}
                    <TextField
                        size="small"
                        placeholder="Search properties…"
                        value={searchVal}
                        onChange={e => {
                            setState(s => ({ ...s, searchVal: e.target.value }))
                            startSearch(e.target.value)
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchOutlined sx={{ fontSize: 18, color: '#9ca3af' }} />
                                </InputAdornment>
                            ),
                            endAdornment: searchVal ? (
                                <InputAdornment position="end">
                                    <IconButton size="small" onClick={() => {
                                        setState(s => ({ ...s, searchVal: '' }))
                                        startSearch('')
                                    }}>
                                        <CloseOutlined sx={{ fontSize: 16, color: '#9ca3af' }} />
                                    </IconButton>
                                </InputAdornment>
                            ) : null,
                        }}
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2.5,
                                bgcolor: '#f9fafb',
                                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: PRIMARY },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: PRIMARY },
                            },
                        }}
                    />

                    {/* Filter */}
                    <FilterComponent
                        filterOptions={filterOptions as FilterParamProps[]}
                        onFilter={onFilter}
                    />

                    {/* Refresh */}
                    <Tooltip title="Refresh">
                        <IconButton
                            onClick={() => getProperties({ processVariable: 'refreshing' })}
                            disabled={refreshing}
                            sx={{
                                border: '1px solid #e5e7eb',
                                borderRadius: 2,
                                bgcolor: '#fff',
                                flexShrink: 0,
                                '&:hover': { bgcolor: '#f9fafb' },
                            }}
                        >
                            {refreshing
                                ? <CircularProgress size={18} sx={{ color: PRIMARY }} />
                                : <Refresh sx={{ fontSize: 20, color: '#6b7280' }} />
                            }
                        </IconButton>
                    </Tooltip>

                    {/* Add Property */}
                    <Button
                        variant="contained"
                        startIcon={<Add />}
                        onClick={() => navigate('/new_property')}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 700,
                            fontSize: 13,
                            bgcolor: PRIMARY,
                            borderRadius: 2.5,
                            px: 2.5,
                            py: 1,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                            boxShadow: '0 2px 8px rgba(140,124,12,.3)',
                            '&:hover': { bgcolor: '#6b5e09', boxShadow: '0 4px 16px rgba(140,124,12,.4)' },
                        }}
                    >
                        Add Property
                    </Button>
                </Box>

                {!properties?.length || loading || searching ? (
                    <NoData
                        message={`You don't have any property.`}
                        createMessage={searchVal ? undefined : `Add New Property`}
                        onCreate={() => navigate('/new_property')}
                        searchVal={searchVal}
                        loading={loading || searching}
                    />
                ) : (
                    <>
                        {/* Property list */}
                        <Box>
                            {properties.map(item => (
                                <ProperyInfo item={item} key={item._id} />
                            ))}
                        </Box>

                        <TablePagination
                            component="div"
                            count={count}
                            page={page}
                            onPageChange={(_, newPage: number) => {
                                getProperties({ newPage, newPageSize: pageSize, processVariable: 'loading', searchVal })
                            }}
                            rowsPerPage={pageSize}
                            onRowsPerPageChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                                getProperties({ newPage: 0, newPageSize: parseInt(e.target.value, 10), processVariable: 'loading', searchVal })
                            }}
                            rowsPerPageOptions={[6, 12, 24]}
                            sx={{ mt: 3 }}
                        />
                    </>
                )}
            </Box>
        )
    }

export default Connect(mapStateToProps, mapDispatchToProps)(Properties)
const person = {
    name: 'brian'
}
